import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Typography, Grid, Button, TextField } from '@mui/material';
import config from 'src/config';
import { useNavigate } from 'react-router-dom';
import { removeKey, removeToken, requestOtp, verifyOtp } from 'src/services/auth.service';
import { AuthHeader } from 'src/components/auth/header';
import { AuthFooter } from 'src/components/auth/footer';

class VerifyEmailPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            otp_length: 6,
            verifying: true,

            // payload
            otp: '',
        }

    }

    async componentDidMount() {

        this.setState({ verifying: true });

        // TODO: Check if user is already verified


        // Request OTP
        let otpResponse = await requestOtp();
        if (otpResponse.error) {
            alert('Error: ' + otpResponse.error);
            await removeToken();
            await removeKey('username');
            this.props.navigate('/login');
            return;
        }

        this.setState({ verifying: false });
    }

    validateOtp(otp) {
        if (!otp) {
            return false;
        }

        if (otp.length !== this.state.otp_length) {
            return false;
        }

        return true;
    }

    validateForm() {
        return this.validateOtp(this.state.otp);
    }

    async handleVerifyOtp() {

        if (!this.validateForm()) {
            return;
        }

        this.setState({ verifying: true });

        let payload = {
            otp: this.state.otp
        };

        let verifyOtpRes = await verifyOtp(payload);
        if (verifyOtpRes.error) {
            console.log(verifyOtpRes.error);
            alert('Error: ' + verifyOtpRes.error);
            this.setState({ otp: '', verifying: false });
            return;
        }

        // this.props.navigate('/files');
        window.location.href = '/files';
    }

    render() {

        return (
            <>
                <Helmet>
                    <title> Verify | {config.APP_NAME} </title>
                </Helmet>

                {(this.state.verifying) ? (
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh', p: 2 }}>
                        <Grid item xs={12} sm={8} md={5} lg={4}>
                            <Typography variant="h4" gutterBottom style={{textAlign: 'center'}}>
                                Verifying...
                            </Typography>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh', p: 2 }}>
                        <Grid item xs={12} sm={8} md={5} lg={4} direction={"row"}>


                            <AuthHeader />

                            <Typography variant="h6" gutterBottom sx={{ mt: 20, textAlign: 'center' }}>
                                Enter the verification code
                            </Typography>
                            <Typography color="textSecondary" sx={{ mb: 2, fontSize: 12, textAlign: 'center', color: 'gray' }}>
                                We've sent a 6-digit verification code to your registered email
                            </Typography>

                            <TextField
                                fullWidth
                                name="otp"
                                size='small'
                                placeholder='••••••'
                                type='text'
                                value={this.state.otp}
                                onChange={(e) => {
                                    const otp = e.target.value;
                                    if (otp.length <= this.state.otp_length) {
                                        this.setState({ otp });
                                    }
                                }}
                                onKeyDown={(e) => {
                                    // if key is enter
                                    if (e.key === 'Enter') {
                                        this.handleVerifyOtp();
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        letterSpacing: '0.3em', fontSize: '1.5em', textAlign: 'center', fontWeight: 'bold'
                                    },
                                }}
                                sx={{
                                    mb: 2,
                                    input: {
                                        textAlign: 'center'
                                    }
                                }}
                            />

                            <Button
                                fullWidth
                                size="large"
                                variant="contained"
                                onClick={this.handleVerifyOtp.bind(this)}
                                disabled={!this.validateForm()}
                                xs={12} sm={8} md={5} lg={4}
                                sx={{ mb: 20 }}
                            >
                                Verify
                            </Button>

                            <AuthFooter />
                        </Grid>
                    </Grid>
                )}
                
            </>
        )
    }
}

export default function (props) {
    const navigate = useNavigate();

    return <VerifyEmailPage {...props} navigate={navigate} />;
}
